import { useQuery } from 'react-query'
import { fiveMinutesInMiliseconds } from 'src/config/constants'
import { getClinicsInCityForSelectedTreatment } from 'src/services/api/clinic'
import { useIsCityVariant } from './useIsCityVariant'
import { useTreatmentPurpose } from './useTreatmentPurpose'
import { useGeolocation } from './useGeolocation'
import { useCityVariantData } from './useCityVariantData'
import { useIsAllClinicsVariant } from './useIsAllClinicsVariant'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'

export const useCityClinics = () => {
  const { clinicId } = useConfig()
  const treatmentPurposeId = useTreatmentPurpose()
  const isCityVariant = useIsCityVariant()
  const { cityName } = useCityVariantData()
  const isAllClinicsVariant = useIsAllClinicsVariant()
  const { district } = useChoiceState()
  const { latitude, longitude } = useGeolocation()

  const result = useQuery(
    ['clinicsForTreatmentInCityOrDistrict', cityName, district, treatmentPurposeId],
    () => getClinicsInCityForSelectedTreatment(clinicId, treatmentPurposeId!, cityName, district, latitude, longitude),
    {
      retry: 3,
      enabled: !!treatmentPurposeId && ((isCityVariant && !!cityName) || (isAllClinicsVariant && !!district)),
      staleTime: fiveMinutesInMiliseconds,
    }
  )

  return result
}
